<template>
<div class="swaychat-group-time swaychat-row">
  <div class="swaychat-status swaychat-bounceIn">
    <h5><span>{{ date }}</span></h5> </div>
</div>
</template>

<script>
import moment from 'moment'

export default {
  props: [
    'created_at'
  ],
  computed: {
    date() {
      return moment(this.created_at).calendar()
    }
  }

}
</script>
